import React, { Component } from 'react';

class Collapsable extends Component {
  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown = (e) => {
    if (e.ctrlKey && e.key === 'Enter') { // ctrl + enter to close edit panel
      this.props.handleDone && this.props.handleDone();
      e.stopPropagation();
      e.preventDefault();
    }
  }

  render() {
    return (
      <span />
    )
  }
}

export default Collapsable;



// WEBPACK FOOTER //
// ./src/components/Collapsable.js